"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArrowIconSvg = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const Icon = styled_components_1.default.svg `
    margin: 0 auto;

    path {
        fill: #888;
    }

    rect {
        fill: none;
    }
`;
const ArrowIconSvg = () => (react_1.default.createElement(Icon, { viewBox: "0 0 16 16", width: "16px", height: "16px" },
    react_1.default.createElement("g", { transform: "translate(-193 -515)" },
        react_1.default.createElement("path", { d: "M9,10V2H8v8H5l3.5,4L12,10Z", transform: "translate(210 531) rotate(180)" }),
        react_1.default.createElement("rect", { width: "16", height: "16", transform: "translate(193 515)" }))));
exports.ArrowIconSvg = ArrowIconSvg;
//# sourceMappingURL=ArrowIcon.js.map